import React from 'react';
import CandidateTrackerComponent from './CandidateTracker/CandidateTracker';

function CandidateTracker() {
  return <CandidateTrackerComponent />;
}

export default CandidateTracker;